<script>
export default {
    name: 'ShoppingCartMixin',
    methods: {
        addProductToShoppingCart (userId, warehouseId, product, quantity, storeModule = "shoppingCart") {
            product.quantity = quantity;
            this.$store.commit(storeModule + '/addProductToShoppingCart', {
                userId: userId,
                warehouseId: warehouseId,
                product: product
            });
        },
        addRecipientToShoppingCart (userId, warehouseId, recipient, storeModule = "shoppingCart") {
            this.$store.commit(storeModule + '/addRecipientToShoppingCart', {
                userId: userId,
                warehouseId: warehouseId,
                recipient: recipient
            });
        },
        getProductQuantity (userId, warehouseId, externalProductId, storeModule = "shoppingCart") {
            let data = this.$store.getters[storeModule + '/getProductsInShoppingCart'](userId);
            if (data && warehouseId in data && externalProductId in data[warehouseId]) {
                return data[warehouseId][externalProductId].quantity;
            }
            return 0;
        },
        getProductsInCart (userId, warehouseId, storeModule = "shoppingCart") {
            let data = this.$store.getters[storeModule + '/getProductsInShoppingCart'](userId);
            if (data && warehouseId in data) {
                return Object.values(data[warehouseId])
                    .filter(product => 'external_id' in product);
            }
            return [];
        },
        getRecipientsInCart (userId, warehouseId, storeModule = "shoppingCart") {
            let data = this.$store.getters[storeModule + '/getRecipientsInShoppingCart'](userId);
            if (data && warehouseId in data && '_recipients' in data[warehouseId]) {
                return data[warehouseId]['_recipients'];
            }
            return [];
        },
        getNumberOfProductsInCart (userId, warehouseId, storeModule = "shoppingCart") {
            return this.getProductsInCart(userId, warehouseId, storeModule).length;
        },
        getTotalNumberOfProductsInCart(userId, warehouseId, storeModule = "shoppingCart") {
            let count = 0;
            let products = this.getProductsInCart(userId, warehouseId, storeModule);
            products.forEach(product => {
                count += parseInt(product.quantity);
            });
            return count;
        },
        removeProductFromCart (userId, warehouseId, productExternalId, storeModule = "shoppingCart") {
            this.$store.commit(storeModule + '/removeProductFromCart', {
                userId: userId,
                warehouseId: warehouseId,
                productExternalId: productExternalId
            });
        },
        removeProductsFromCart (userId, warehouseId, storeModule = "shoppingCart") {
            this.$store.commit(storeModule + '/removeProductsFromCart', {
                userId: userId,
                warehouseId: warehouseId
            });
        },
        removeRecipientFromCart (userId, warehouseId, addressId, storeModule = "shoppingCart") {
            this.$store.commit(storeModule + '/removeRecipientFromCart', {
                userId: userId,
                warehouseId: warehouseId,
                addressId: addressId
            });
        }
    }
}
</script>
